<template>
<table>
  <thead class="orders-history-list-component__thead"><tr>
    <th>Заказ</th>
    <th>Адрес доставки</th>
    <th>Сумма</th>
    <th>Статус</th>
  </tr></thead>
  <tbody>
    <router-link v-for="o of orders"
                 :key="o.id"
                 :to="{ name: 'orders', params: { id: o.id } }"
                 :replace="!!$route.params.id"
                 class="orders-history-list-component__item"
    >
      <td class="orders-history-list-component__two-row-cell">
        <span>Заказ №{{ o.number }}</span>
        <span>{{ o.submitted_at.datetime_at }}</span>
      </td>
      <td class="orders-history-list-component__two-row-cell">
        <span title="Название адреса">{{ o.delivery_address && o.delivery_address.name || '—' }}</span>
        <span>{{ getShortAddress(o) }}</span>
      </td>
      <td class="orders-history-list-component__two-row-cell orders-history-list-component__money">
        <span>{{ priceToText(o.total_price) }}</span>
        <span></span>
      </td>
      <td>
        <span class="orders-history-list-component__status-badge" :style="getStatusInfo(o).style">
          {{ getStatusInfo(o).text }}
        </span>
      </td>
    </router-link>
  </tbody>
</table>
</template>

<script>
import addressToString from '@/helpers/addressToString';
import priceToText from '@/helpers/priceToText';

export default {
  props: {
    orders: {
      type: Array,
      required: true,
    },

    getStatusInfo: {
      required: true,
      type: Function,
    },
  },

  methods: {
    priceToText,

    getShortAddress(order) {
      if (order.delivery_method.id === 'pickup') {
        return 'Самовывоз';
      } else if (order.delivery_method.id === 'on_premise') {
        return 'В заведении';
      }

      return order.delivery_address && addressToString(order.delivery_address, true) || '—';
    },
  },
};
</script>

<style lang="less">
@import '../../../pages/profile/common.less';

.orders-history-list-component {
  &__thead {
    @apply bg-light text-dark-lighter text-xs font-medium;
    > tr > th {
      @apply px-3 py-2 text-left;
    }
  }
  &__item {
    .profile__list-item-link();
    @apply table-row;
    &:not(:last-child) {
      @apply border-b;
    }
    min-height: theme('height.16');
    > td {
      @apply px-2 py-1 align-middle;
      &:first-child {
        @apply pl-3;
      }
      &:last-child {
        @apply pr-3;
      }
    }
  }
  &__two-row-cell {
    > * {
      @apply block my-2 leading-none;
      &:first-child {
        @apply text-sm;
      }
      &:last-child {
        @apply text-xs text-dark-light;
      }
    }
  }
  &__money {
    @apply whitespace-no-wrap;
  }
  &__status-badge {
    @apply rounded-full bg-primary-lighter text-xs py-1 px-3 block text-center whitespace-no-wrap;
  }
}
</style>
